/**
 * The LayerManager wraps your application and creates two adjacent divs for
 * rendering your application and housing Layers.
 */
import { ComponentChildren } from 'preact';
import { useCallback, useState } from 'preact/compat';
import { LayerContext, LayerContextProps } from './LayerContext';
import LayerHost from './LayerHost';

type LayerManagerProps = {
  children?: ComponentChildren;
};

export function LayerManager({ children }: LayerManagerProps) {
  const [defaultHost, setDefaultHost] = useState<Element>();
  //const context = useContext(LayerContext);
  const defaultHostRef = useCallback((el: Element | null) => {
    // ref callbacks fire after the component has been unnmounted so we do not
    // want to set state in this use-case
    if (el !== null) {
      setDefaultHost(el);
    }
  }, []);

  return (
    <LayerContext.Consumer>
      {(value: LayerContextProps) => {
        let defaultHostContext = {};
        if (defaultHost) {
          defaultHostContext = {
            getRootLayerHost: () => {
              return defaultHost;
            },
            getLayerHost: () => {
              return defaultHost;
            }
          };
        }
        const layerContext = value.getLayerHost ? value : defaultHostContext;
        return (
          <LayerContext.Provider value={layerContext}>
            {children}
            {!value.getLayerHost && <LayerHost ref={defaultHostRef} />}
          </LayerContext.Provider>
        );
      }}
    </LayerContext.Consumer>
  );
}
